module.exports = __webpack_public_path__ + "static/media/about-us.8e1e820f.png";